import { combineReducers } from 'redux';

import sitesReducer from './sites/sites';
import filesReducer from './files/files';
import selectedElementReducer from './selectedElement/reducer';
import copyReducer from './copyFile';
import editorReducer from './editor/reducer';
import backForwardReducer from './backForward';
import postsDataReducer from './postsData';
import domainsListReducer from './domainList';
import templateGeneratorReducer from './templateGenerator';

export default combineReducers({
	sites: sitesReducer,
	files: filesReducer,
	selectedElement: selectedElementReducer,
	copyFile: copyReducer,
	editor: editorReducer,
	navigation: backForwardReducer,
	postsData: postsDataReducer,
	domains: domainsListReducer,
	templateGenerator: templateGeneratorReducer
});
